import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const STOP_RECOGNITION = 'VOICE_TO_TEXT/STOP_RECOGNITION';

export const stopRecognitionActionSchema = objectSchemaOf<
  IStopRecognitionAction
>({
  type: Joi.string().required().valid(STOP_RECOGNITION),
  payload: Joi.object({
    conversationId: Joi.string().required(),
  }).required(),
});

export interface IStopRecognitionAction {
  type: typeof STOP_RECOGNITION;
  payload: {
    conversationId: string;
  };
}

export const stopRecognition = actionCreator({
  type: STOP_RECOGNITION,
  schema: stopRecognitionActionSchema,
});
